import React from 'react'
import template from './template'

const weatherFormOptions = {
    template: template,
    fields: {
        types: {
            className: 'row fieldset-group spark-pad-b-1 uppercase-checkbox-labels spark-checkbox-group',
            label: 'Weather types',
            error: <i>At least one type is required</i>
        },
        airports: {
            label: "Airports, FIR's or VAAC's",
            attrs: {placeholder: "Type airports, FIR's or VAAC's ...", thinLabel: "(Comma separated)"},
            error: <i>Airports are required (IATA or ICAO codes)</i>
        },
        count: {
            label: 'Row count',
            attrs: {min: 0},
            nullOption: false,
            error: <i>Row count must be from range 0 to 10</i>
        }
    }
}

export default weatherFormOptions


// WEBPACK FOOTER //
// ./src/screens/weather/components/WeatherForm/options.js